// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.statistic-blocks {
  margin-bottom: 40px;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-end;
  gap: 20px;
  justify-content: space-between;
  align-items: end;
}

.statistic-block {
  width: 420px;
  height: 120px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-radius: 15px;
  border: 2px solid #d9d9d9;
}

.statistic-block > div:first-child {
  padding-left: 2em;
  width: 65%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.statistic-block > div:nth-child(2) {
  width: 35%;
  height: 100%;
  background-color: #434c63;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 15% 15px 15px 15%;
}

.grade {
  font-size: 40px;
  font-weight: 600;
  color: #434c63;
}
.description {
  font-size: 16px;
  font-weight: 600;
  color: #d32c2c;
}

.grade-description {
  font-size: 18px;
  font-weight: 400;
  color: #a2a2a2;
}

.mobile-statistic {
  display: none;
}

@media screen and (max-width: 1160px) {
  .statistic-block {
    width: 300px;
    height: 100px;
  }

  .grade {
    font-size: 30px;
    font-weight: 600;
    color: #434c63;
  }

  .grade-description {
    font-size: 16px;
    font-weight: 400;
    color: #a2a2a2;
  }
}

@media screen and (max-width: 800px) {
  .statistic-blocks {
    justify-content: center;
    align-items: center;
  }
}

@media screen and (max-width: 670px) {
  .statistic-block {
    width: 400px;
  }

  .statistic-block:first-child {
    margin-bottom: 20px;
  }
}

@media screen and (max-width: 520px) {
  .mobile-statistic {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .statistic-block {
    width: 320px;
    height: 100px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/ReportCard/style.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;AACF","sourcesContent":[".statistic-blocks {\n  margin-bottom: 40px;\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n  justify-content: flex-end;\n  gap: 20px;\n  justify-content: space-between;\n  align-items: end;\n}\n\n.statistic-block {\n  width: 420px;\n  height: 120px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 15px;\n  border: 2px solid #d9d9d9;\n}\n\n.statistic-block > div:first-child {\n  padding-left: 2em;\n  width: 65%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.statistic-block > div:nth-child(2) {\n  width: 35%;\n  height: 100%;\n  background-color: #434c63;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border-radius: 15% 15px 15px 15%;\n}\n\n.grade {\n  font-size: 40px;\n  font-weight: 600;\n  color: #434c63;\n}\n.description {\n  font-size: 16px;\n  font-weight: 600;\n  color: #d32c2c;\n}\n\n.grade-description {\n  font-size: 18px;\n  font-weight: 400;\n  color: #a2a2a2;\n}\n\n.mobile-statistic {\n  display: none;\n}\n\n@media screen and (max-width: 1160px) {\n  .statistic-block {\n    width: 300px;\n    height: 100px;\n  }\n\n  .grade {\n    font-size: 30px;\n    font-weight: 600;\n    color: #434c63;\n  }\n\n  .grade-description {\n    font-size: 16px;\n    font-weight: 400;\n    color: #a2a2a2;\n  }\n}\n\n@media screen and (max-width: 800px) {\n  .statistic-blocks {\n    justify-content: center;\n    align-items: center;\n  }\n}\n\n@media screen and (max-width: 670px) {\n  .statistic-block {\n    width: 400px;\n  }\n\n  .statistic-block:first-child {\n    margin-bottom: 20px;\n  }\n}\n\n@media screen and (max-width: 520px) {\n  .mobile-statistic {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n  }\n\n  .statistic-block {\n    width: 320px;\n    height: 100px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
